var initSliders = function initSliders() {
  new Swiper(".img-carousel__swiper", {
    slidesPerView: 1.5,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".img-carousel__next",
      prevEl: ".img-carousel__prev"
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      990: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
  });
  new Swiper(".testimonials__swiper", {
    slidesPerView: 1.5,
    spaceBetween: 20,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      990: {
        slidesPerView: 3,
        spaceBetween: 50
      }
    }
  });
};
export { initSliders };